import { render, staticRenderFns } from "./ToolbarDataLanguage.vue?vue&type=template&id=26b55a7e&"
import script from "./ToolbarDataLanguage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ToolbarDataLanguage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports